<template>
  <div class="login-area">
    <div class="login-area-img">
      <p class="title">{{ $t('尊敬的用户，') }}</p>
      <p class="title welcome">{{ $t('欢迎') }}<span class="bold">{{ $t('登录企业网银') }}</span></p>
      <ul class="points">
        <li class="points-item">{{ $t('CBiBank最懂你的银行') }}</li>
        <li class="points-item">{{ $t('小微企业的境外港湾') }}</li>
        <li class="points-item">{{ $t('足不出户，连接您与全球财富') }}</li>
      </ul>
    </div>
    <div class="login-area-box">
      <!-- 1.欢迎 -->
      <div
        class="login-welcome"
        v-show="loginState === 'page-welcome'">
        <p class="title">{{ $t('企业网银登录') }}</p>
        <div class="default-area">
          <div class="guide-img">
            <img src="@/assets/image/login/guide.png" alt="guide">
          </div>
          <p class="text">{{ $t('请插入CBiBank企业专属UKey进行登录') }}</p>
          <el-button
            class="login-btn"
            type="primary"
            :loading="loginLoading"
            @click="handleLoginWelcome">
            {{ $t('登录') }}
          </el-button>
        </div>
        <p
          class="login-tip"
          @click="handleGoGuide">
          {{ $t('登录指南') }}
        </p>
      </div>
      <!-- 密码控件 签名控件 或者 ukey未正确安装 -->
      <div
        class="login-welcome"
        v-show="loginState === 'page-error'">
        <p class="title">{{ $t('企业网银登录') }}</p>
        <div
          class="error-area">
          <div class="error-img">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-shibai"></use>
            </svg>
          </div>
          <p
            class="error-text">
            {{ $t('您尚未安装CBiBank网银控件，或安装不正确。') }}
          </p>
          <el-button
            class="login-btn"
            type="primary"
            @click="SET_LOGIN_STATE('page-welcome')">
            {{ $t('确定') }}
          </el-button>
        </div>
      </div>
      <!-- 2.登录表单 -->
      <LoginForm ref="loginForm" v-show="loginState === 'page-form'"/>
      <!-- 3.设置密码 -->
      <SetPassword type="SET" v-if="loginState === 'page-set-password'" />
      <!-- 4.忘记密码 -->
      <div
        class="login-reset-password"
        v-if="loginState === 'page-reset-password'">
        <StepOne v-if="resetState === 'stepOne'"></StepOne>
        <StepTwo v-if="resetState === 'stepTwo'"></StepTwo>
        <SetPassword type="RESET" v-if="resetState === 'stepThree'"></SetPassword>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LoginForm from './LoginForm'
import SetPassword from './setPassword/SetPassword'
import StepOne from './resetPassword/StepOne'
import StepTwo from './resetPassword/StepTwo'
import { mapState, mapMutations } from 'vuex'
import httpBaseUrl from '@/utils/http/base-url'
// 密码控件
import ctrl from '@/utils/plugins/PassGuardCtrl'
// 签名控件
import { signObj } from '@/utils/plugins/SignMessenger'
import { ajax } from '@/utils/http/ajax'
// usbKeyUtil
import { needWebsock } from '@/utils/USBKeyUtil'
// SampleAtlCtrl
import { SampleAtlCtrl } from '@/utils/sampleAtlCtrl'
const { pge: Pge, pgeInit } = ctrl
export default {
  components: {
    LoginForm,
    SetPassword,
    StepOne,
    StepTwo
  },
  data () {
    return {
      // 是否开启密码控件
      keyCodeControlEnabled: this.$_core.keyCodeControlEnabled,
      // 是否开启签名控件
      signDataEnabled: this.$_core.signDataEnabled,
      // 是否安装密码控件
      isKeyCode: false,
      // 是否安装签名控件
      isSignData: false,
      // 是否插入UKey
      isUKey: false,
      // 是否安装websocket控件，ie不需要所以默认已安装
      isWebsocket: true,
      // ukey控制器
      ukeyCtrl: null,
      // 登录方式：0-验证码登录，1-密码登录
      loginType: 0,
      pgeCtrl: null,
      // ukey交互时，浏览器是否需要websock。IE浏览器不需要websocket
      needWebsock: true,
      // 是否已安装签名控件 这个跟isSignData冲突了 注释掉
      // signMessengerFlag: true,
      // 密码登录错误3次后，需要填写验证码
      pwdNeedVcode: false,
      // 当前tab
      currentTab: '',
      loadingInterval: null,
      qrcode: '',
      // 人脸验证通过后放入session
      faceSession: '',
      // 客户号
      customerId: '',
      // 用户号
      userId: '',
      // 点击登录时的loading
      loginLoading: false
    }
  },
  computed: {
    ...mapState('login', ['loginState', 'resetState'])
  },
  mounted () {
    // ！！！由于该页内要判断密码控件等是否成功安装，所以把初始化方法放在该文件，而不是子组件内
    if (this.keyCodeControlEnabled) {
      this.handleInitKeyCode()
    }
    if (this.signDataEnabled) {
      this.handleInitSignData()
      this.handleInitUkey()
    }
  },
  methods: {
    ...mapMutations('login', ['SET_LOGIN_STATE', 'SET_USER_INFO']),
    // 密码控件初始化
    handleInitKeyCode () {
      // 密码登录输入框
      const pwdLoginInput = this.$refs.loginForm.$refs.passwordLogin.$refs.passwordInputPassword.$refs.inputWrapper
      // 请求通讯加密两个参数(随机数pgeRZRandNum和数据B pgeRZDataB)
      ajax.request({
        url: `${process.env.BASE_URL}${httpBaseUrl.NO_PREFIX_URL}/SkeyAndeEnstr`,
        type: 'GET',
        async: false,
        success: (response) => {
          const targetStr = '(' + response.responseText + ')'
          // eslint-disable-next-line
          const retJson = eval(targetStr)
          const random = retJson.sKey
          const datab = retJson.enStr
          const nowTime = new Date().getTime()
          // 初始化实例前 要重置下pges数组
          window.pges = []
          // 登录密码
          // TODO:要对 window.pgeCtrl 重新赋值，否则pgeCtrl实例的settings是个空对象
          // TODO:确认密码控件下的密码输入框是否也只是数字和字母
          this.pgeCtrl = window.pgeCtrl = new Pge({
            pgePath: './ocx/', // 控件下载目录，可以指定绝对路径，如"http://www.baidu.com/download/"
            pgeId: '_ocx_password', // 控件id
            pgeEditType: 0, // 控件显示类型,0(星号),1(明文)
            pgeEreg1: '', // 输入过程中字符类型限制，如"[0-9]*"表示只能输入数字
            pgeEreg2: '^[\x21-\x7e]{6,12}$', // 输入完毕后字符类型判断条件，与pgeditor.pwdValid()方法对应
            pgeMaxLength: 12, // 允许最大输入长度
            pgeTabIndex: 1, // tab键顺序
            pgeClass: 'ocx_style', // 控件css样式
            pgeInstallClass: 'ocx_style_init', // 针对安装或升级的css样式
            tabCallBack: 'checkCode', // 火狐tab键回调函数,设置要跳转到的对象ID
            pgeWindowID: 'password' + nowTime + 10,
            pgeRZRandNum: random,
            pgeRZDataB: datab,
            placeholder: '密码/Password'
          })
          // 绘制控件标签
          this.pgeCtrl.pwdhtml(pwdLoginInput, this.pgeCtrl.load())
          // pgeCtrl.pwdhtml('passwordContainer1', this.pgeditor1.load())
          // pgeCtrl.pwdhtml('passwordContainer2', this.pgeditor2.load())
          // 初始化
          pgeInit()
          setTimeout(() => {
            const pwdInput = document.getElementById('_ocx_password')
            if (pwdInput != null && pwdInput.length !== 0) {
              this.isKeyCode = true
            } else {
              this.isKeyCode = false
            }
          }, 1000)
        }
      })
    },
    // 签名控件初始化
    handleInitSignData () {
      // 初始化签名控件，判断是否安装 => 迁移至App.vue
      // this.smAreaData = signObj.createTag()
      // 由于vue的v-html不会立刻更新DOM 所以下面涉及到的DOM操作要放在nexttick中
      this.$nextTick(() => {
        // edge浏览器或者是chrome等现代浏览器
        if (signObj.env.edge) {
          signObj.getVersion((version) => {
            if (!version) {
              this.isSignData = false
            } else {
              this.isSignData = true
            }
          })
        } else {
          var signObjVersion = signObj.getVersion()
          if (signObjVersion === 0) {
            this.isSignData = false
          } else {
            this.isSignData = true
          }
        }
      })
    },
    // ukey初始化
    handleInitUkey () {
      // 初始化usb-key（用于读取证书）
      if (needWebsock()) {
        try {
          this.ukeyCtrl = window.ukeyCtrl = new SampleAtlCtrl('{2CD78E57-000B-4F03-AF36-59D84E9B2763}')
        } catch (err) {
          console.error(err)
          this.ukeyCtrl = null
          this.needWebsock = false
          // 非ie浏览器，没有安装websocket控件
          // 这个与 SampleAtlCtrl 有关连？？即使SampleAtlCtrl正常执行 websocket貌似也会未安装
          // SampleAtlCtrl应该会根据浏览器自动判断是否需要websocket
          this.isWebsocket = false
        }
      } else {
        this.needWebsock = false
      }
    },
    // 鼠标监听事件，读取USB-Key证书DN，反显客户号和用户号
    getSignData () {
      const interval = setInterval(() => {
        getIds.call(this)
        if (this.isUKey) {
          clearInterval(interval)
        }
      }, 300)
      setTimeout(function () {
        if (interval) {
          clearInterval(interval)
        }
      }, 2000)
      // 获取客户号与用户号
      function getIds () {
        if (this.signDataEnabled) {
          if (!this.needWebsock) {
            this.ukeyCtrl = document.getElementById('CBIB')
            window.lRet = this.ukeyCtrl.GetCertDN()
            var certDn = window.lRet
            if (certDn === '' || certDn === null) {
              return
            }
            setIds.call(this, certDn)
          } else {
            this.ukeyCtrl.GetCertDN((result, response) => {
              window.lRet = response
              var certDn = window.lRet
              if (certDn === '' || certDn === null) {
                return
              }
              setIds.call(this, certDn)
            })
          }

        }
      }
      // 设置客户号与用户号
      function setIds (certDn) {
        const dnResult = certDn.split(',')[0]
        const userInfo = dnResult.split(',')[0].split('@')[1]
        const customerId = userInfo.substr(0, 10)
        const userId = userInfo.substr(10, 17)
        this.isUKey = true
        // 存储到vuex中
        this.SET_USER_INFO({
          customerId,
          userId
        })
      }
    },
    // 检查控件安装情况
    myCheckInstall () {
      // 是否开启密码控件
      console.warn(this.keyCodeControlEnabled)
      // 是否安装密码控件
      console.warn(this.isKeyCode)
      // 是否安装websocket控件，ie不需要所以默认已安装
      console.warn(this.isWebsocket)
      // 是否开启签名控件
      console.warn(this.signDataEnabled)
      // 是否安装签名控件
      console.warn(this.isSignData)
      if ((this.keyCodeControlEnabled && !this.isKeyCode) || !this.isWebsocket || (this.signDataEnabled && !this.isSignData)) {
        this.SET_LOGIN_STATE('page-error')
        return false
      }
      if (this.signDataEnabled && !this.isUKey) {
        this.$talert('您尚未插入Ukey，请插入后重试。')
        return false
      }
      return true
    },
    // 开始登录
    handleLoginWelcome () {
      this.loginLoading = true
      // 先取得客户号、用户号、以及UKey是否插入
      this.getSignData()
      setTimeout(() => {
        // 检查是否安装控件
        if (this.myCheckInstall()) {
          // 安装成功后跳转登录页
          this.SET_LOGIN_STATE('page-form')
        }
        this.loginLoading = false
      }, 2000)
    },
    // 登录指南
    handleGoGuide () {
      this.$router.push({
        name: 'LoginGuide'
      })
    }
  }
}

</script>

<style scoped lang="less">
.login-area {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 80px - 110px - 24px);
  background-image: url('../../../assets/image/login/bg.png');
  background-size: 100% 100%;

  .login-area-img {
    position: relative;
    width: 439px;
    height: 552px;
    margin-top: 16px;
    margin-right: -11px;
    padding: 63px 46px 0;
    padding-left: 46px;
    background-image: url('../../../assets/image/login/left-bg.png');
    background-size: 100% 100%;
    .title {
      font-size: 26px;
      font-weight: lighter;
      color: #FFFFFF;
      line-height: 40px;
      font-family: PingFangSC-Light, PingFang SC;
      .bold {
        font-weight: bold;
        font-family: PingFangSC-Light, PingFang SC;
      }
    }
    .welcome {
      position: relative;
      &::after {
        position: absolute;
        left: 0;
        bottom: -10px;
        content: '';
        width: 27px;
        height: 2px;
        background: #FFFFFF;
      }
    }
    .points {
      margin-top: 97px;
      padding-left: 12px;
      .points-item {
        position: relative;
        margin-bottom: 20px;
        height: 14px;
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 14px;
        &::before {
          position: absolute;
          left: -8px;
          top: 50%;
          transform: translateY(-50%);
          content: '';
          width: 4px;
          height: 4px;
          border-radius: 2px;
          background: #FFFFFF;
        }
      }
    }
  }
  .login-area-box {
    width: 400px;
    height: 490px;
    padding-left: 12px;
    margin-left: -12px;
    background: #FFFFFF;
    box-shadow: 0px 6px 16px 0px rgba(17, 41, 158, 0.05);
    border-radius: 0px 10px 10px 0px;
    text-align: center;
    font-weight: 400;
    .login-welcome {
      width: 100%;
      height: 100%;
      overflow: hidden;
      .title {
        margin-top: 60px;
        margin-bottom: 46px;
        font-size: 24px;
        font-weight: 600;
        color: #131523;
        line-height: 24px;
      }
      .default-area {
        .guide-img {
          width: 180px;
          height: 140px;
          margin: 0 auto;
          >img {
            display: block;
            width: 100%;
            height: 100%;
          }
        }
        .text {
          margin-top: 20px;
          margin-bottom: 60px;
          font-size: 12px;
          color: #4A6AFF;
          line-height: 14px;
        }
      }
      .error-area {
        .error-img {
          width: 80px;
          height: 80px;
          margin: 0 auto;
          > .icon {
            width: 100%;
            height: 100%;
          }
        }
        .error-text {
          margin-top: 52px;
          margin-bottom: 88px;
          font-size: 14px;
          color: #F34359;
          line-height: 14px;
          padding: 0 15px;
        }
      }
      .login-btn {
        width: 320px;
        height: 46px;
      }

      .login-tip {
        margin-top: 20px;
        font-size: 12px;
        color: #5A607F;
        line-height: 14px;
        cursor: pointer;

        &:hover {
          color: #4A6AFF;
        }
      }
    }
  }
}
</style>
